import { Size, LogGroup, Scale } from "./MyHelpers";
import { IRandomInterval } from "./Context/RandomInterval";
import { ISystemContext } from "./Context/SystemContext";
import { JackpotText } from "./JackpotText";
import { MoneyFormatter } from "./MoneyFormatter";
import { FontResource } from "./ResourceManager/FontResource";
import { Resourceful } from "./ResourceManager/Resourceful";
import { ResourceIdentifier } from "./ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "./ResourceManager/ResourceManager";
import { SpriteResource } from "./ResourceManager/SpriteResource";
import { ScreenProtocolScope, ScreenProtocol } from "./ScreenProtocol";
import { PickBonusMessages } from "./slot/PickBonus/PickMessage";
import { CanvasSprite } from "./slot/Sprite/CanvasSprite";
import { Settings } from "./Settings";
import { ZIndex } from "./ZIndex";
import { JackpotDisplayParams } from "./JackpotDisplayParams";
import { IJackpotDisplay } from "./IJackpotDisplay";
import { JackPotTextParams } from "./JackPotTextParams";
import { JackpotLevel, JackpotValue2 } from "./api";

export class JackpotDisplayPyramid extends  IJackpotDisplay {
	protected view: HTMLElement = null;
	protected viewSize: Size = null;
	//Creating elements for JP
	//protected jpTitle: HTMLElement = null;
	protected titleImage: HTMLElement = null;
	protected DragonJackpotContainer: HTMLElement = null;
	protected diamondImage: HTMLElement = null;
	//protected diamondvalue: HTMLElement = null;
	//protected diamondText: HTMLElement = null;
	protected GrandDragonJackpotContainer: HTMLElement = null;
	protected rubyImage: HTMLElement = null;
	//protected rubyvalue: HTMLElement = null;
	//protected rubyText: HTMLElement = null;
	protected MiniDragonJackotContainer: HTMLElement = null;
	protected emeraldImage: HTMLElement = null;
	protected emeraldText: HTMLElement = null;
	protected MinorDragonJackotContainer: HTMLElement = null;
	protected saphireImage: HTMLElement = null;


	protected commonpath: string = null;
	protected basepath: string = null;
	protected jackpot: string = null;

	protected resid: ResourceIdentifier = null;
	protected screenProtocolScope: ScreenProtocolScope = null;

	//crea el contenedor como elemento HTMLElement
	//protected jackpotContainer: HTMLElement = null;

	// protected diamondSpriteAnim: CanvasSprite = null;
	// protected diamondLocation: Point = new Point(8,-34);
	protected diamondStartTimer: IRandomInterval = null;

	// protected rubyAnim: CanvasSprite = null;
	// protected rubyLocation: Point = new Point(365,80);
	protected rubyStartTimer: IRandomInterval = null;

	// protected shappireAnim: CanvasSprite = null;
	// protected shappireLocation: Point = new Point(635,920);
	protected shappireStartTimer: IRandomInterval = null;

	// protected emeraldAnim: CanvasSprite = null;
	// protected emeraldLocation: Point = new Point(617,720);
	protected emeraldStartTimer: IRandomInterval = null;

	//LOAD JACKPOT SPRITE
	protected DiamondSpriteJackpot: CanvasSprite;
	protected GrandSpriteJackpot: CanvasSprite;
	protected MinorSpriteJackpot: CanvasSprite;
	protected MiniSpriteJackpot: CanvasSprite;


	protected titleSpriteAnim: CanvasSprite = null;
	protected titleStartTimer: IRandomInterval = null;


	// protected jp1text: JackpotText = null;
	// protected jp2text: JackpotText = null;
	// protected jp3text: JackpotText = null;
	// protected jp4text: JackpotText = null;

	protected moneyFormatter: MoneyFormatter = new MoneyFormatter(1);

	protected screenProtocol: ScreenProtocol = null;

	protected logGroup: LogGroup = new LogGroup("JackpotDisplayPyramid");

	protected systemContext: ISystemContext = null;

	protected allJpTimers: IRandomInterval[] = [];

	protected allJpSpriteAnim: CanvasSprite[] = [];

	protected TitleContainer: HTMLElement = null;

	public constructor(params: JackpotDisplayParams) {
		super(params);

		this.systemContext = params.systemContext.CreateSubContext("JackpotDisplayPyramid");

		this.resid = params.resid.Add("JackpotDisplayPyramid");
		this.screenProtocolScope = new ScreenProtocolScope("JackpotDisplayPyramid");

		this.screenProtocol = params.screenProtocol;
		//Ruta de background de los niveles jackpot
		this.jackpot = Settings.ResourcesFolder + "multigame/multigame/img/";
		this.viewSize = params.viewSize;

		// this would be "view" with jackpot frames
		this.view = document.createElement("div");
		this.view.classList.add(this.resid.ID());
		this.view.style.position = "absolute";
		this.view.style.top = Scale.Ypx(0);
		this.view.style.left = Scale.Xpx(0);
		this.view.style.width = this.viewSize.Width + "px";
		this.view.style.height = this.viewSize.Height + "px";
		this.view.style.zIndex = "" + ZIndex.JackpotDisplay;

		//Title Container 
		this.TitleContainer = document.createElement("div");
		this.TitleContainer.setAttribute("id", "TitleContainer");
		this.TitleContainer.classList.add(this.resid.ScopedResourceName("TitleContainer"));
		this.TitleContainer.style.display = "block";
		this.TitleContainer.style.justifyContent = "center";
		this.TitleContainer.style.alignContent = "center";
		this.TitleContainer.style.left = Scale.Xpx(0);
		this.TitleContainer.style.bottom = "0px";
		this.TitleContainer.style.position = "absolute";

		// need to get position from image
		this.TitleContainer.style.width = Scale.Wpx(1100);
		this.TitleContainer.style.height = Scale.Hpx(500);
		this.view.appendChild(this.TitleContainer);



		//Diamond  titleContainer DIV

		//Diamond Jackpot
		this.DragonJackpotContainer = document.createElement("div");
		this.DragonJackpotContainer.setAttribute("id", "DragonJackpotContainer");
		this.DragonJackpotContainer.classList.add(this.resid.ScopedResourceName("DragonJackpotContainer"));
		this.DragonJackpotContainer.style.display = "flex";
		this.DragonJackpotContainer.style.justifyContent = "center";
		this.DragonJackpotContainer.style.alignContent = "center";
		this.DragonJackpotContainer.style.right = Scale.Xpx(-57);
		this.DragonJackpotContainer.style.top = Scale.Ypx(23);
		this.DragonJackpotContainer.style.position = "absolute";

		// need to get position from image
		this.DragonJackpotContainer.style.width = Scale.Wpx(1805);
		this.DragonJackpotContainer.style.height = Scale.Hpx(350);
		this.view.appendChild(this.DragonJackpotContainer);

		//Ruby Jackpot
		this.GrandDragonJackpotContainer = document.createElement("div");
		this.GrandDragonJackpotContainer.setAttribute("id", "GrandDragonJackpotContainer");
		this.GrandDragonJackpotContainer.classList.add(this.resid.ScopedResourceName("ruby"));
		this.GrandDragonJackpotContainer.style.position = "absolute";
		this.GrandDragonJackpotContainer.style.display = "flex";
		this.GrandDragonJackpotContainer.style.top = Scale.Ypx(353);
		this.GrandDragonJackpotContainer.style.right = Scale.Xpx(-150);
		this.GrandDragonJackpotContainer.style.width = Scale.Wpx(1380);
		this.GrandDragonJackpotContainer.style.height = Scale.Hpx(320);
		this.view.appendChild(this.GrandDragonJackpotContainer);



		//Emerald Jackpot
		this.MiniDragonJackotContainer = document.createElement("div");
		this.MiniDragonJackotContainer.setAttribute("id", "MiniDragonJackotContainer");
		this.MiniDragonJackotContainer.classList.add(this.resid.ScopedResourceName("emerald"));
		this.MiniDragonJackotContainer.style.position = "absolute";
		this.MiniDragonJackotContainer.style.top = Scale.Ypx(650);
		this.MiniDragonJackotContainer.style.right = Scale.Xpx(0);
		this.MiniDragonJackotContainer.style.width = Scale.Wpx(940);
		this.MiniDragonJackotContainer.style.height = Scale.Hpx(250);
		this.view.appendChild(this.MiniDragonJackotContainer);

		//Shappire Jackpot
		this.MinorDragonJackotContainer = document.createElement("div");
		this.MinorDragonJackotContainer.setAttribute("id", "MinorDragonJackotContainer");
		this.MinorDragonJackotContainer.classList.add(this.resid.ScopedResourceName("MinorDragonJackotContainer"));
		this.MinorDragonJackotContainer.style.position = "absolute";
		this.MinorDragonJackotContainer.style.top = Scale.Ypx(881);
		this.MinorDragonJackotContainer.style.right = Scale.Xpx(0);
		this.MinorDragonJackotContainer.style.width = Scale.Wpx(750);
		this.MinorDragonJackotContainer.style.height = Scale.Hpx(200);
		this.view.appendChild(this.MinorDragonJackotContainer);





		// recieve message from first screen
		this.screenProtocol.AddReceiveMessageHandler(PickBonusMessages.DiamondAnimation.msgname, (m) => this.DiamondAnimation((<PickBonusMessages.DiamondAnimation>m)), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(PickBonusMessages.JpShowFinish.msgname, (m) => this.JpShowFinish((<PickBonusMessages.JpShowFinish>m)), this.screenProtocolScope);
	}


	protected DiamondAnimation(message: PickBonusMessages.DiamondAnimation) {
		this.allJpTimers.forEach((anim: IRandomInterval) => {
			anim.Stop();
		});

		if (message.hitJp == 1) {
			this.MiniSpriteJackpot.Start(true);
		}

		if (message.hitJp == 2) {
			this.MinorSpriteJackpot.Start(true);
		}

		if (message.hitJp == 3) {
			this.GrandSpriteJackpot.Start(true);
		}

		if (message.hitJp == 4) {
			this.DiamondSpriteJackpot.Start(true);
		}
	}

	protected JpShowFinish(message: PickBonusMessages.JpShowFinish) {
		this.allJpSpriteAnim.forEach((anim: CanvasSprite) => {
			if (anim.sprite.Running()) {
				anim.Repeat(false);
				//anim.Start(false);
				// anim.sprite.Stop();
				// anim.sprite.Update();
			}
		});

		this.StartAnimations();
	}

	public override async PrepareResources(loadingStage: LoadingStage,resourceManager: IWriteOnlyResourceManager): Promise<void> {
		if(loadingStage != LoadingStage.System) return;
		
		// jackpot frames image
		//resourceManager//.Add(new ImageResource(this.jackpot + "background.3.1.png", this.resid.ScopedResourceName("jackpotframes")));
		//resourceManager.Add(new ImageResource(this.jackpot + "diamond_pot_title.png", this.resid.ScopedResourceName("jackpotTitle")));
		//resourceManager.Add(new ImageResource(this.jackpot + "diamond_frame.png", this.resid.ScopedResourceName("jpDiamondMa")));

		//load Sprite Jackpot 

		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotDisplayPyramid/Sprites/Gold_Dragon", this.resid.Add("Gold_Dragon"), true, this.logGroup.Add("Gold_Dragon"), true));
		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotDisplayPyramid/Sprites/Grand_Dragon", this.resid.Add("Grand_Dragon"), true, this.logGroup.Add("Grand_Dragon"), true));
		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotDisplayPyramid/Sprites/Minor_Dragon", this.resid.Add("Minor_Dragon"), true, this.logGroup.Add("Minor_Dragon"), true));
		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotDisplayPyramid/Sprites/Mini_Dragon", this.resid.Add("Mini_Dragon"), true, this.logGroup.Add("Mini_Dragon"), true));

		this.TitlePrepare(resourceManager);
		resourceManager.Add(new FontResource(this.jackpot + "fonts/newzone.ttf", this.resid.ScopedResourceName("JackpotFont")));

	}

	public TitlePrepare(resourceManager: IWriteOnlyResourceManager) {
		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotDisplayPyramid/Sprites/DragonLink_Title", this.resid.Add("title"), true, this.logGroup.Add("title"), true));
	}

	public TitleLoaded(resourceManager: IReadOnlyResourceManager) {
		this.titleSpriteAnim = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("title")).sprite, canvasSize: new Size(Scale.W(1100), Scale.H(500))});
		this.titleSpriteAnim.View().style.position = "absolute";
		//this.titleSpriteAnim.View().style.bottom="-91px";
		this.TitleContainer.appendChild(this.titleSpriteAnim.View());
	}

	public override async ResourcesLoaded(loadingStage: LoadingStage,resourceManager: IReadOnlyResourceManager): Promise<void> {
		if(loadingStage != LoadingStage.System) return ;
		this.TitleLoaded(resourceManager);




		let jp4TextParams: JackPotTextParams = {

			logGroup: this.logGroup.Add("White"),
			width: Scale.W(1500),//Scale.W(1500),
			height: Scale.H(195),//Scale.H(195)
			color:  "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
			bold: true
		}

		//this.jackpotTextMapping[JackpotLevel.Jp4].View().style.position = "absolute";
		this.jackpotTextMapping[JackpotLevel.Jp4] = new JackpotText(jp4TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.left = Scale.Xpx(346);
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.top = Scale.Ypx(95); //84
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.position = "absolute";
		this.DragonJackpotContainer.appendChild(this.jackpotTextMapping[JackpotLevel.Jp4].View());



		//JackpotFont 3

		let jp3TextParams: JackPotTextParams = {

			logGroup: this.logGroup.Add("Red"),
			width: Scale.W(990),//Scale.W(1100)
			height: Scale.H(140),//Scale.H(160)
			color:  "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
			bold: true
		}
		this.jackpotTextMapping[JackpotLevel.Jp3] = new JackpotText(jp3TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.left = Scale.Xpx(196);
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.top = Scale.Ypx(111);
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.position = "absolute";
		this.GrandDragonJackpotContainer.appendChild(this.jackpotTextMapping[JackpotLevel.Jp3].View());

		//JackpotFont 2

		let jp2TextParams: JackPotTextParams = {

			logGroup: this.logGroup.Add("Green"),
			width: Scale.W(750),
			height: Scale.H(135),
			color:  "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
			bold: true
		}
		this.jackpotTextMapping[JackpotLevel.Jp2] = new JackpotText(jp2TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.left = Scale.Xpx(171);
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.top = Scale.Ypx(66);
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.position = "absolute";
		this.MiniDragonJackotContainer.appendChild(this.jackpotTextMapping[JackpotLevel.Jp2].View());


		//JackpotFont 1

		let jp1TextParams: JackPotTextParams = {

			logGroup: this.logGroup.Add("Blue"),
			width: Scale.W(550),
			height: Scale.H(100),
			color:  "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
			bold: true
		}
		this.jackpotTextMapping[JackpotLevel.Jp1] = new JackpotText(jp1TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.left = Scale.Xpx(210);
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.top = Scale.Ypx(60);
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.position = "absolute";
		this.MinorDragonJackotContainer.appendChild(this.jackpotTextMapping[JackpotLevel.Jp1].View());


		//this.DragonJackpotContainer.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("diamond_frame")).CssBackground();


		this.DiamondSpriteJackpot = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("Gold_Dragon")).sprite, canvasSize: new Size(Scale.W(1805), Scale.H(375))});
		//this.DiamondSpriteJackpot.Start();
		this.DragonJackpotContainer.appendChild(this.DiamondSpriteJackpot.View());


		//this.GrandDragonJackpotContainer.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("ruby_frame")).CssBackground();
		this.GrandSpriteJackpot = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("Grand_Dragon")).sprite, canvasSize: new Size(Scale.W(1250), Scale.H(320))}); //new Size(Scale.W(1400), Scale.H(320))})
		//this.GrandSpriteJackpot.Start();
		this.GrandDragonJackpotContainer.appendChild(this.GrandSpriteJackpot.View());


		//this.MiniDragonJackotContainer.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("emerald_frame")).CssBackground();
		this.MinorSpriteJackpot = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("Minor_Dragon")).sprite, canvasSize: new Size(Scale.W(950), Scale.H(250))});
		//this.MinorSpriteJackpot.Start();
		this.MinorSpriteJackpot.ScaleNonUniform(1.1, 1);
		this.MiniDragonJackotContainer.appendChild(this.MinorSpriteJackpot.View());



		//this.MinorDragonJackotContainer.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("sapphire_frame")).CssBackground();
		this.MiniSpriteJackpot = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("Mini_Dragon")).sprite, canvasSize: new Size(Scale.W(766), Scale.H(200))});
		//this.MiniSpriteJackpot.Start();
		this.MinorDragonJackotContainer.appendChild(this.MiniSpriteJackpot.View());

		this.allJpSpriteAnim.push(this.DiamondSpriteJackpot);
		this.allJpSpriteAnim.push(this.GrandSpriteJackpot);
		this.allJpSpriteAnim.push(this.MinorSpriteJackpot);
		this.allJpSpriteAnim.push(this.MiniSpriteJackpot);


		//this.jpTitle.appendChild(this.titleImage);
		//this.view.appendChild(this.jpTitle);

		// this.diamondSpriteAnim = new CanvasSprite(resourceManager.Get<SpriteResource>(this.resid.Add("diamond")).sprite);


		// // get position from image
		// this.diamondSpriteAnim.View().style.position = "absolute";
		// this.diamondSpriteAnim.View().style.top = this.diamondLocation.x+"px"; //"282px";
		// this.diamondSpriteAnim.View().style.left = this.diamondLocation.y+"px";//  "-34px";
		// this.diamondSpriteAnim.View().style.zIndex = "4";
		//HIDE 
		//this.view.appendChild(this.diamondSpriteAnim.View()); // puts animation on screen, just like any other element


		// this.rubyAnim = new CanvasSprite(resourceManager.Get<SpriteResource>(this.resid.Add("ruby")).sprite);

		// // get position from image
		// this.rubyAnim.View().style.position = "absolute";
		// this.rubyAnim.View().style.top = this.rubyLocation.x+"px";  //"607px";
		// this.rubyAnim.View().style.left = this.rubyLocation.y+"px";  //"80px";
		// this.rubyAnim.View().style.zIndex = "4";

		//HIDE 
		//this.view.appendChild(this.rubyAnim.View()); // puts animation on screen, just like any other element

		//this.rubyAnim.Start(false); //starts animation


		// this.shappireAnim = new CanvasSprite(resourceManager.Get<SpriteResource>(this.resid.Add("sapphire")).sprite);

		// // get position from image
		// this.shappireAnim.View().style.position = "absolute";
		// this.shappireAnim.View().style.top = this.shappireLocation.x+"px";  //"860px";
		// this.shappireAnim.View().style.left = this.shappireLocation.y+"px"; //"920px";
		// this.shappireAnim.View().style.zIndex = "4";
		// //HIDE 
		//this.view.appendChild(this.shappireAnim.View()); // puts animation on screen, just like any other element

		// this.emeraldAnim = new CanvasSprite(resourceManager.Get<SpriteResource>(this.resid.Add("emerald")).sprite);

		// // get position from image
		// this.emeraldAnim.View().style.position = "absolute";
		// this.emeraldAnim.View().style.top = this.emeraldLocation.x+"px";  //"870px";
		// this.emeraldAnim.View().style.left = this.emeraldLocation.y+"px";  //"720px";
		// this.emeraldAnim.View().style.zIndex = "4";

		//HIDE 
		//this.view.appendChild(this.emeraldAnim.View()); // puts animation on screen, just like any other element



		// repeat at random intervals winthin 5 to 10 seconds
		this.diamondStartTimer = this.systemContext.TimingContext().CreateRandomInterval("diamondStartTimer", 10000, 30000, () => this.DiamondSpriteJackpot.Start(false));
		this.rubyStartTimer = this.systemContext.TimingContext().CreateRandomInterval("rubyStartTimer", 10000, 30000, () => this.GrandSpriteJackpot.Start(false));
		this.shappireStartTimer = this.systemContext.TimingContext().CreateRandomInterval("shappireStartTimer", 10000, 30000, () => this.MiniSpriteJackpot.Start(false));
		this.emeraldStartTimer = this.systemContext.TimingContext().CreateRandomInterval("emeraldStartTimer", 10000, 30000, () => this.MinorSpriteJackpot.Start(false));
		this.titleStartTimer = this.systemContext.TimingContext().CreateRandomInterval("titleStartTimer", 10000, 30000, () => this.titleSpriteAnim.Start(false));

		this.allJpTimers.push(this.diamondStartTimer);
		this.allJpTimers.push(this.rubyStartTimer);
		this.allJpTimers.push(this.shappireStartTimer);
		this.allJpTimers.push(this.emeraldStartTimer);

		this.StartAnimations();

		this.Update();

		this.jackpotTextMapping[JackpotLevel.Jp4].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp4].Start();

		this.jackpotTextMapping[JackpotLevel.Jp3].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp3].Start();

		this.jackpotTextMapping[JackpotLevel.Jp1].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp1].Start();

		this.jackpotTextMapping[JackpotLevel.Jp2].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp2].Start();
	}

	// deleted too much, this is how this particular game gets displayed to screen,
	// just returns its own div element
	public View(): HTMLElement {
		return this.view;
	}

	// if we need to update any animation...
	public Update(): void {
		// animation needs to be updated for frames to go forward
		// this.diamondSpriteAnim.Update();
		// this.rubyAnim.Update();
		// this.shappireAnim.Update();
		// this.emeraldAnim.Update();
		this.titleSpriteAnim.Update();
		this.jackpotTextMapping[JackpotLevel.Jp4].Draw();
		this.jackpotTextMapping[JackpotLevel.Jp3].Draw();
		//Change STYLE JP1 and JP2
		this.jackpotTextMapping[JackpotLevel.Jp1].Draw();
		this.jackpotTextMapping[JackpotLevel.Jp2].Draw();
		//UPDATE JACKPOT ANIM
		this.DiamondSpriteJackpot.Update();
		this.GrandSpriteJackpot.Update();
		this.MinorSpriteJackpot.Update();
		this.MiniSpriteJackpot.Update();
	}

	public StopAnimations(): void {
		// stop animations and their timer to startup in near future

		// if (this.diamondSpriteAnim != null) this.diamondSpriteAnim.Stop();
		// this.diamondStartTimer.Stop();

		// if (this.rubyAnim != null) this.rubyAnim.Stop();
		// this.rubyStartTimer.Stop();

		// if (this.shappireAnim != null) this.shappireAnim.Stop();
		// this.shappireStartTimer.Stop();

		// if (this.emeraldAnim != null) this.emeraldAnim.Stop();
		// this.emeraldStartTimer.Stop();

		if (this.titleSpriteAnim != null) this.titleSpriteAnim.Stop();
		this.titleStartTimer.Stop();
	}

	public StartAnimations(): void {

		//start within 5 seconds
		if (this.DiamondSpriteJackpot != null) {
			this.diamondStartTimer.Start();
		}

		if (this.GrandSpriteJackpot != null) {
			this.rubyStartTimer.Start();
		}

		if (this.MiniSpriteJackpot != null) {
			this.shappireStartTimer.Start()
		}

		if (this.MinorSpriteJackpot != null) {
			this.emeraldStartTimer.Start()
		}

		if (this.titleSpriteAnim != null) {
			this.titleStartTimer.Start()
		}
	}

	// protected jpValues: JackpotValue2[] = [];
	// public UpdateValues(jackpotValues: JackpotValue2[]): void {
	// 	this.jpValues = jackpotValues;
	// 	if (this.pauseJackpotValues) {
	// 		console.log("IsJackpot");
	// 		return
	// 	}
	// 	let jp1: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp1);

	// 	if (jp1 != null) {
	// 		this.jackpotTextMapping[JackpotLevel.Jp1].SetTarget(jp1.CurrentMultipliedValue);
	// 	}

	// 	let jp2: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp2);
	// 	if (jp2 != null) {
	// 		this.jackpotTextMapping[JackpotLevel.Jp2].SetTarget(jp2.CurrentMultipliedValue);
	// 	}

	// 	let jp3: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp3);
	// 	if (jp3 != null) {
	// 		this.jackpotTextMapping[JackpotLevel.Jp3].SetTarget(jp3.CurrentMultipliedValue);
	// 	}

	// 	let jp4: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp4);
	// 	if (jp4 != null) {
	// 		this.jackpotTextMapping[JackpotLevel.Jp4].SetTarget(jp4.CurrentMultipliedValue);
	// 	}
	// }

	public TitleHide() {
		this.titleSpriteAnim.Hide();
		this.titleSpriteAnim.Stop();
	}
	public TitleShow() {
		this.titleSpriteAnim.Show();
		this.titleSpriteAnim.Update();
	}

	// public Reset() {
	// 	console.log("Reset JackpotValues:");
	// 	this.jpValues.forEach((jp) => {
	// 		console.log("JackpotValuesLevel:", jp.JackpotLevel, "ResetValue:", jp.ResetValue);
	// 	});
	// }

	// public Resume() {
	// 	console.log("Resume JackpotValues:");
	// 	this.pauseJackpotValues = false;
	// 	this.jpValues.forEach((jp) => {
	// 		console.log("JackpotValuesLevel:", jp.JackpotLevel, "CurrentValue:", jp.CurrentValue);
	// 	});
	// 	this.UpdateValues(this.jpValues);
	// }

	// protected pauseJackpotValues = false;
	// public Pause() {
	// 	console.log("Pause JackpotValues");
	// 	this.pauseJackpotValues = true;
	// }
}
